/**
 * plugins/vuetify.js
 *
 * Framework documentation: https://vuetifyjs.com`
 */

// Styles
import '@mdi/font/css/materialdesignicons.css'
import '@material-symbols/font-400/outlined.css'
import 'vuetify/styles'
import '@/styles/autofill.scss'
import '@/styles/shell.scss'

// Composables
import { createVuetify } from 'vuetify'
import { h } from 'vue'
import { VDateInput } from 'vuetify/labs/VDateInput'
import { VFileUpload } from 'vuetify/labs/VFileUpload'
import { VMaskInput } from 'vuetify/labs/VMaskInput'
import { VVideo } from 'vuetify/labs/VVideo'
import { VIcon } from 'vuetify/components'
import { aliases, mdi } from 'vuetify/iconsets/mdi'

const msIconset = {
  component: (props) => {
    const className = 'material-symbols-outlined'
    return h(VIcon, {
      ...props,
      tag: 'i',
      class: [className, props.class],
      style: {
        fontSize: '18px',
        lineHeight: 1,
        ...(props.style || {})
      },
      innerHTML: props.icon,
      icon: undefined
    })
  }
}

// https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
export default createVuetify({
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: {
      mdi,
      ms: msIconset
    }
  },
  theme: {
    defaultTheme: 'dark',
    themes: {
      dark: {
        colors: {
          error: '#B00020',
          'on-error': '#FFFFFF'
        }
      },
      light: {
        colors: {
          error: '#B00020',
          'on-error': '#FFFFFF'
        }
      }
    }
  },
  components: {
    VDateInput,
    VFileUpload,
    VMaskInput,
    VVideo
  }
})
